import React, { useEffect, useState }  from "react";
import { Form, Input, InputNumber, DatePicker, Radio, Select, Checkbox, Upload, Button, Row, Col, Spin, notification } from 'antd';
import type { UploadProps } from 'antd/es/upload';
import { LinkOutlined, PlusOutlined, UploadOutlined } from '@ant-design/icons';

import individualForm from "../../media/Company Share form.pdf"
import Signature from "../../components/Signature";
import config from "../../config.json";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { ArrowLeftOutlined } from '@ant-design/icons';

const Company = () => {
  const navigate = useNavigate();
  const goBack = () => {
    navigate(-1);
  }
    const [physicalForm, setPhysicalForm] = useState(false);
    const [loading, setLoading] = useState(false);
    const [success, setSuccess] = useState(false);
    const [submitted, setSubmit] = useState(false);
    const [kitta, setKitta] = useState<number>(1000);
    const [rate, setRate] = useState<number>(1);
    const [form] = Form.useForm();
    const [members, setMembers] = useState<string[]>([""]);
    const [signatureCleared, setSignatureCleared] = useState(false);


    const onFinish = async (values: any) => {

        var formData = {
            isIndividual: true,
            kitta: values.kitta,
            rate: values.rate,
            amount: values.amount,
            amountInWords: values.amountInWords,
            shareholder_firstname: values.firstName,
            shareholder_middlename: values.middleName,
            shareholder_lastname: values.lastName,
            shareholderdob: values.dob,
            dateformatAD: values.dateformat == "AD",
            citizenshipno: values.citizenshipno,
            issued_date_citizenship: values.issuedDateCitizenship,
            issued_district_citizenship: values.issuedDistrictCitizenship,
            citizenship_issued_municipality: values.citizenshipIssuedMunicipality,
            anchal_permanent: values.anchalPermanent,
            district_permanent: values.districtPermanent,
            isMunicipality_permanent: values.isMunicipality == "Municipality",
            ward_no_permanent: values.wardNoPermanent,
            tol_permanent: values.tolPermanent,
            houseno_permanent: values.housenoPermanent,
            shareholder_phonenumber_permanent: values.shareholderPhonenumberPermanent,
            pradesh_temporary: values.pradeshTemporary,
            district_temporary: values.districtTemporary,
            municipality_type_temporary: values.municipalityTypeTemporary,
            ward_no_temporary: values.wardNoTemporary,
            tol_temporary: values.tolTemporary,
            houseno_temporary: values.housenoTemporary,
            shareholder_phoneno_temporary: values.phonenoTemporary,
            shareholder_email: values.shareholderEmail,
    
            shareholder_spouse: values.shareholderSpouse,
            shareholder_fathername: values.shareholderFathername,
            shareholder_grandfatherOrfatherinlawname: values.GFatherOrFILName,
            deposit_type: values.depositType,
            document_citizenshipfilecopy: values.citizenshipFile,
            document_self_portrait: values.selfPortrait,
    
            date_applied: values.dateApplied,
            signature: values.signature,
    
    
    
          }
        }

        const onFinishPhysicalForm = async (values: any) => {
            var physicalForm = {
                firstName : values.firstName,
                middleName : values.middleName,
                lastName : values.lastName,
                depositType : values.depositType,
                filledForm : values.companyfilledForm.file.originFileObj,
                payslip : values.payslip.file.originFileObj
            }
    
            console.log(physicalForm)
            
            setLoading(true);
    
            const URL = (config.env === "prod" ? config.prodURL : config.env === "test" ? config.testURL : config.localURL) + "companysharephysicalform";
            console.log("URL: ", URL)
            try{
                const response = await axios.post(URL , physicalForm, {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                      },
                });
                setSuccess(true);
                setSubmit(true);
                console.log("Form submitted successfully:: ", response.data);
            } catch(error){
                notification["error"]({
                    message: "Submit Error",
                    description: "Something went wrong. Please try again later.",
                    placement: 'topRight', // Options: 'topLeft', 'topRight', 'bottomLeft', 'bottomRight'
                  });
                  console.error('Error uploading file:', error);
            }
            setLoading(false)
        }

        const amount = kitta * rate;


        const calculateAmount = () => {
          const kitta = form.getFieldValue('kitta');
          const rate = form.getFieldValue('rate');
          if (kitta && rate) {
            form.setFieldsValue({ amount: kitta * rate });
          }
        };
       
        const addMember = () => setMembers([...members, '']);
        const removeMember = (index: number) => setMembers(members.filter((_, i) => i !== index));
      
      
        const uploadProps: UploadProps = {
          beforeUpload: (file) => {
            return false; // Prevent automatic upload
          }
        };
      
        const handleClearSignature = (cleared : any) => {
          setSignatureCleared(cleared);
        };
  

        useEffect(() => {
            window.scrollTo(0, 0);
          calculateAmount();
        }, [])

    return(
        <div className="about-container">
        <div className="content-left">
        <p style={{ display: 'flex' }}>
          <ArrowLeftOutlined onClick={goBack}></ArrowLeftOutlined>Go back
        </p>
             <h1>Company Share</h1>
             <button onClick={(e) => setPhysicalForm(!physicalForm)}>{!physicalForm ? "Physical Form" : "Company Form"}</button>
             <a style={{margin: 10}} href="/#/individual"><button  >Individual Share</button></a>
             {physicalForm? 
             (
                <>
                <div>
                <a style={{ fontSize: '17px', marginTop: '10px' }} href={individualForm} download >Download Physical Form for Company Share </a><LinkOutlined />
    
                </div>
                <Form className="form" form={form} onFinish={onFinishPhysicalForm}>
                <h2>Personal Information</h2>
                    <Row>
                    <Form.Item style={{ marginRight: '10px' }} label="First Name" rules={[{ required: true, message: 'Please enter first name!' }]} name="firstName">
                        <Input width={200}></Input>
                    </Form.Item>
                    <Form.Item style={{ marginRight: '10px' }} label="Middle Name" name="middleName">
                        <Input width={200}></Input>
                    </Form.Item>
                    <Form.Item style={{ marginRight: '10px' }} label="Last Name" rules={[{ required: true, message: 'Please enter last name' }]} name="lastName">
                        <Input width={200}></Input>
                    </Form.Item>
                    </Row>
                    <h2>Payment Information</h2>
                <Form.Item style={{ marginRight: '10px' }} label="Payment Deposit Option"  rules={[{ required: true, message: 'Please select payment deposit type' }]} name="depositType">
                  <Checkbox.Group>
                    <Checkbox value="selfDeposit">Self Deposit</Checkbox>
                    <Checkbox value="bankTransfer">Bank Transfer</Checkbox>
                    <Checkbox value="check">Cheque</Checkbox>
                    <Checkbox value="other">Other</Checkbox>
                  </Checkbox.Group>
                </Form.Item>
                
                <div>
                      <p><b>Ac Name: </b>Brahma Jyoti Holdings Public Limited</p>
                        
                        <p><b>Bank: </b>Laxmi Sunrise Bank, Kamalpokhari</p>
                        <p><b>Ac No: </b>0691563348011026</p>
                        <p><b>Swift Code: </b>LXBLNPKA</p>
                      </div>
                   
                    <Form.Item style={{ marginRight: '10px' }} label="Individual Share Filled Form" name="companyfilledForm" rules={[{ required: true, message: 'Please upload filled company share form!' }]}>
                      <Upload >
                        <Button icon={<UploadOutlined />}>Upload</Button>
                      </Upload>
                    </Form.Item>
                    <Form.Item style={{ marginRight: '10px' }} label="Payslip" name="payslip" rules={[{ required: true, message: 'Please upload payslip!' }]}>
                      <Upload >
                        <Button icon={<UploadOutlined />}>Upload</Button>
                      </Upload>
                    </Form.Item>
                    <Form.Item>
                        <Button type="primary" htmlType="submit">Submit</Button>
                    </Form.Item>
                </Form>
                </>
             ):
             (
                <div>

           
              <Form className="form"
                style={{ background: "#eaf4f4" }}
                form={form}
                layout="horizontal"
                onFinish={onFinish}
                initialValues={{
                  kitta: 0,
                  rate: 0,
                }}
              >
                {/* Share Information Section */}
                <h2>Share Information</h2>
                <Row gutter={16}>

                  <Form.Item style={{ marginRight: '10px' }} label="Kitta" name="kitta" rules={[{ required: true, message: 'Please input kitta!' }]}>
                    <InputNumber min={1} onChange={calculateAmount} style={{ width: '100%' }} />
                  </Form.Item>


                  <Form.Item style={{ marginRight: '10px' }} label="Rate" name="rate" rules={[{ required: true, message: 'Please input rate!' }]}>
                    <InputNumber min={0} onChange={calculateAmount} style={{ width: '100%' }} />
                  </Form.Item>


                  <Form.Item style={{ marginRight: '10px' }} label="Amount" name="amount">
                    <InputNumber value={amount} disabled style={{ width: '100%' }} />
                  </Form.Item>

                </Row>
                {/* Personal Information Section */}
                <h2>Personal Information</h2>
                <Row >

                  <Form.Item style={{ marginRight: '10px' }} label="First Name" name="firstName" rules={[{ required: true, message: 'Please input your first name!' }]}>
                    <Input />
                  </Form.Item>
                  <Form.Item style={{ marginRight: '10px' }} label="Middle Name" name="middleName" rules={[{ required: false, message: 'Please input your first name!' }]}>
                    <Input />
                  </Form.Item>


                  <Form.Item style={{ marginRight: '10px' }} label="Last Name" name="lastName" rules={[{ required: true, message: 'Please input your last name!' }]}>
                    <Input />
                  </Form.Item>

                  <Form.Item style={{ marginRight: '10px' }} label="Date of Birth" name="dob" rules={[{ required: true, message: 'Please enter your date of birth!' }]}>
                    {/* <DatePicker format="YYYY/MM/DD" style={{ width: '100%' }} /> */}
                    <Input/>
                  </Form.Item>

                </Row>

                {/* Citizenship Section */}
                <h2>Citizenship</h2>
                <Row gutter={16}>

                  <Form.Item style={{ marginRight: '10px' }} label="Citizenship number" name="citizenshipno" rules={[{ required: true, message: 'Please input your citizenship number!' }]}>
                    <Input  />
                  </Form.Item>

                  <Form.Item style={{ marginRight: '10px' }} label="Issued Date" name="issuedDateCitizenship" rules={[{ required: true, message: 'Please select issued date!' }]}>
                  <Input  />
                  </Form.Item>

                  <Form.Item style={{ marginRight: '10px' }} label="District" name="issuedDistrictCitizenship" rules={[{ required: true, message: 'Please select a district!' }]}>
                    {/* <Select style={{ width: '200px' }}>
                      {districtsOfNepal.map((districtsOfNepal) => (
                        <Select.Option key={districtsOfNepal} value={districtsOfNepal}>
                          {districtsOfNepal}
                        </Select.Option>
                      ))}
                    </Select> */}
                    <Input  />
                  </Form.Item>

                </Row>

                {/* Address Section */}
                <h2>Permanent Address (According to Citizenship Card)</h2>
                <Row gutter={16}>

                  <Form.Item style={{ marginRight: '10px' }} label="Pradesh" name="pradeshPermanent" rules={[{ required: true, message: 'Please input your temporary address!' }]}>
                    <Input />
                  </Form.Item>
                  <Form.Item style={{ marginRight: '10px' }} label="District" name="districtPermanent" rules={[{ required: true, message: 'Please input your temporary address!' }]}>
                    <Input />
                  </Form.Item>



                  <Form.Item style={{ marginRight: '10px' }} label="Municipality/Rural Municipality" name="isMunicipality" rules={[{ required: true, message: 'Please select municipality type!' }]}>
                    <Radio.Group>
                      <Radio value="Municipality">Municipality</Radio>
                      <Radio value="Rural Municipality">Rural Municipality</Radio>
                    </Radio.Group>
                  </Form.Item>

                </Row>
                <Row gutter={16}>

                  <Form.Item style={{ marginRight: '10px' }} label="Ward No" name="wardNoPermanent" rules={[{ required: true, message: 'Please input your ward number!' }]}>
                    <InputNumber min={1} style={{ width: '100%' }} />
                  </Form.Item>


                  <Form.Item style={{ marginRight: '10px' }} label="Tole" name="tolPermanent" rules={[{ required: true, message: 'Please input your tol!' }]}>
                  <Input  />
                  </Form.Item>


                  <Form.Item style={{ marginRight: '10px' }} label="House Number" name="housenoPermanent" rules={[{ required: false, message: 'Please input your house number!' }]}>
                    <InputNumber min={1} style={{ width: '100%' }} />
                  </Form.Item>


                </Row>

                <Form.Item style={{ marginRight: '10px' }} label="Phone Number" name="shareholderPhonenumberPermanent" rules={[{ required: true, message: 'Please input your phone number!' }]}>
                  <Input style={{ width: '140px' }} />
                </Form.Item>
                <Row>




                  {/* )} */}

                  {/* Email */}
                  <Form.Item style={{ marginRight: '10px' }} label="Email" name="email" rules={[{ required: false, message: 'Please input your email!' }]}>
                    <Input type="email" style={{ width: '268px' }} />
                  </Form.Item>

                </Row>


                {/* Team Members Section */}
                <h2>Team Members</h2>
                <Row gutter={16}>

                  <Form.Item style={{ marginRight: '10px' }} label="Chairman" name="chairman" rules={[{ required: true, message: 'Please input chairman!' }]}>
                    <Input style={{ width: '268px' }} />
                  </Form.Item>


                  <Form.Item style={{ marginRight: '10px' }} label="Managing Director" name="managingDirector" rules={[{ required: true, message: 'Please input managing director!' }]}>
                    <Input style={{ width: '268px' }} />
                  </Form.Item>


                  <Form.Item style={{ marginRight: '10px' }} label="Chief Executive Officer" name="ceo" rules={[{ required: true, message: 'Please input CEO!' }]}>
                    <Input style={{ width: '268px' }} />
                  </Form.Item>

                </Row>
                {members.map((member, index) => (
                  <Form.Item style={{ marginRight: '10px' }} key={index} label={`Member ${index + 1}`} name={`member${index}`}>
                    <Input style={{ width: '268px' }} value={member} onChange={(e) => {
                      const newMembers = [...members];
                      newMembers[index] = e.target.value;
                      setMembers(newMembers);
                    }} />
                    <Button onClick={() => removeMember(index)}>Remove</Button>
                  </Form.Item>
                ))}
                <Button style={{ margin: '10px' }} type="dashed" onClick={addMember} icon={<PlusOutlined />}>
                  Add Member
                </Button>
                <Form.Item style={{ marginRight: '10px' }} label="Secretary" name="secretary" rules={[{ required: false, message: 'Please input secretary!' }]}>
                  <Input style={{ width: '268px' }} />
                </Form.Item>
                <h2>Payment Information</h2>
                <Form.Item style={{ marginRight: '10px' }} label="Payment Deposit Option" name="depositType" rules={[{ required: true, message: 'Please select payment option!' }]}>
                  <Checkbox.Group>
                    <Checkbox value="selfDeposit">Self Deposit</Checkbox>
                    <Checkbox value="bankTransfer">Bank Transfer</Checkbox>
                    <Checkbox value="check">Cheque</Checkbox>
                    <Checkbox value="other">Other</Checkbox>
                  </Checkbox.Group>
                </Form.Item>
                
                <div>
                      <p><b>Ac Name: </b>Brahma Jyoti Holdings Public Limited</p>
                        
                        <p><b>Bank: </b>Laxmi Sunrise Bank, Kamalpokhari</p>
                        <p><b>Ac No: </b>0691563348011026</p>
                        <p><b>Swift Code: </b>LXBLNPKA</p>
                      </div>
                {/* File Upload Section */}
                <h2>File Uploads</h2>
                <Row gutter={16}>
                  <Col>
                  <Form.Item style={{ marginRight: '10px' }} label="Company Registration Document" name="companyRegDoc" rules={[{ required: true, message: 'Please upload company registration document!' }]}>
                    <Upload>
                      <Button icon={<UploadOutlined />}>Upload</Button>
                    </Upload>
                  </Form.Item>


                  <Form.Item style={{ marginRight: '10px' }} label="Company Tax Document" name="companyTaxDoc" rules={[{ required: true, message: 'Please upload company registration document!' }]}>
                    <Upload>
                      <Button icon={<UploadOutlined />}>Upload</Button>
                    </Upload>
                  </Form.Item>


                  <Form.Item style={{ marginRight: '10px' }} label="Investors Citizenship Documents" name="citizenshipFiles" rules={[{ required: true, message: 'Please upload company registration document!' }]}>
                    <Upload multiple>
                      <Button icon={<UploadOutlined />}>Upload</Button>
                    </Upload>
                  </Form.Item>
                  <Form.Item style={{ marginRight: '10px' }} label="Payslip" name="payslip" rules={[{ required: true, message: 'Please upload company payment document!' }]}>
                  <Upload >
                    <Button icon={<UploadOutlined />}>Upload</Button>
                  </Upload>
                </Form.Item>
                </Col>
                </Row>

                {/* Signature Section */}
                <h2>Signature</h2>
                <Signature onClear={handleClearSignature} />
                <Form.Item style={{ marginRight: '10px' }} label="Date" name="dateApplied" rules={[{ required: true, message: 'Please select a date!' }]}>
                  <DatePicker format="YYYY/MM/DD" style={{ width: '200px' }} />
                </Form.Item>

                {/* Submit Button */}
                <Form.Item style={{ marginRight: '10px' }}>
                  <Button disabled={loading} type="primary" htmlType="submit">
                    Submit
                  </Button>
                </Form.Item>
              </Form>
              {loading && (
                <div className="loading-overlay">
                  <Spin size="large" /> {/* Ant Design spinner */}
                </div>
              )}
            </div>
             )
             }
           
        </div>
        </div>
    )
}


export default Company;